import React from 'react';
import Alert from 'components/element/Alert';

const FormContainer = ({ title, errorMessage, onCloseAlert, children }) => {
  return (
    <div className="flex-grow flex items-start justify-center px-4 py-10">
      <div className="w-full max-w-xl space-y-8">
        <div className="bg-gray-weakest rounded-lg shadow-md p-8">
          <h2 className="text-3xl font-bold text-center mb-8 text-gray-strongest">
            {title}
          </h2>

          {errorMessage && (
            <Alert type="danger" message={errorMessage} onClose={onCloseAlert} />
          )}

          {children}
        </div>
      </div>
    </div>
  );
};

export default FormContainer;
